import React, { useRef, useState } from 'react';
import { Button, Input } from 'reactstrap';
import UsersAutocomplete from './Numbers/UsersAutocomplete';
import { PROVINCE_OPTIONS, COUNTRY_LIST } from '../utils/constants';
import { toast } from 'react-toastify';

const NumberMaskForm = ({ searchNumber, states, clearSearchedNumbers, resetSelectedNumbers }) => {
  const formRef = useRef(null);
  const [selectedState, setselectedState] = useState('');
  const [country, setCountry] = useState(COUNTRY_LIST[0]);
  const [stateOrProvince, setStateOrProvince] = useState({ label: 'State', value: states || [] });

  const provinces = PROVINCE_OPTIONS?.map(item => item.label);

  const handleClearButton = () => {
    formRef.current.reset();
    setselectedState({ ...selectedState, state: '' });
    clearSearchedNumbers();
    resetSelectedNumbers([]);
  };

  const handleSubmit = () => {
    if (!selectedState.state) {
      toast.error(`Please select a ${stateOrProvince?.label}`);
      return;
    }
    const form = formRef.current;
    const data = {
      qty: form.qty.value || 0,
      state: selectedState.state,
      m1: form['m-1'].value || 'x',
      m2: form['m-2'].value || 'x',
      m3: form['m-3'].value || 'x',
      m4: form['m-4'].value || 'x',
      m5: form['m-5'].value || 'x',
      m6: form['m-6'].value || 'x',
      m7: form['m-7'].value || 'x',
      m8: form['m-8'].value || 'x',
      m9: form['m-9'].value || 'x',
      m10: form['m-10'].value || 'x',
    };

    searchNumber(data);
  };

  const handleSelectState = e => {
    if (e.suggestion !== null) {
      setselectedState({ ...selectedState, state: e.suggestion });
    }
  };

  const handleSelectCountry = e => {
    if (e.suggestion !== null) {
      setCountry(e.suggestion);

      setStateOrProvince({
        label: e.suggestion === COUNTRY_LIST[0] ? 'State' : 'Province',
        value: e.suggestion === COUNTRY_LIST[0] ? states : provinces,
      });

      setselectedState({ ...selectedState, state: '' });
    }
  };

  return (
    <form className="search-sidebar" ref={formRef}>
      <p className="maskForm-label">Quantity</p>
      <Input type="number" name="qty" placeholder="Quantity..." />

      <p className="maskForm-label">Country</p>
      <>
        <UsersAutocomplete
          placeholder="Country..."
          calls={COUNTRY_LIST}
          onChange={handleSelectCountry}
          name="country"
          searchTerm={country || selectedState?.country}
        />
      </>

      <p className="maskForm-label">{stateOrProvince?.label}</p>
      {states && states.length > 0 && (
        <>
          <UsersAutocomplete
            placeholder={`${stateOrProvince?.label}...`}
            calls={stateOrProvince?.value || []}
            onChange={handleSelectState}
            name="state"
            usage="provision"
            searchTerm={selectedState.state}
          />
        </>
      )}

      <p className="maskForm-label">Number Mask</p>
      <div className="maskField-container">
        <Input type="tel" name="m-1" maxLength={1} placeholder="X" className="mask-field" />
        <Input type="tel" name="m-2" maxLength={1} placeholder="X" className="mask-field" />
        <Input type="tel" name="m-3" maxLength={1} placeholder="X" className="mask-field" />
        <p className="mask-divider">-</p>
        <Input type="tel" name="m-4" maxLength={1} placeholder="X" className="mask-field" />
        <Input type="tel" name="m-5" maxLength={1} placeholder="X" className="mask-field" />
        <Input type="tel" name="m-6" maxLength={1} placeholder="X" className="mask-field" />
        <p className="mask-divider">-</p>
        <Input type="tel" name="m-7" maxLength={1} placeholder="X" className="mask-field" />
        <Input type="tel" name="m-8" maxLength={1} placeholder="X" className="mask-field" />
        <Input type="tel" name="m-9" maxLength={1} placeholder="X" className="mask-field" />
        <Input type="tel" name="m-10" maxLength={1} placeholder="X" className="mask-field" />
      </div>
      <div className="NumberSearchFormContainer">
        <div>
          <Button color="primary" style={{ width: '100%' }} onClick={handleSubmit}>
            Search
          </Button>
        </div>
        <div>
          <Button color="primary" style={{ width: '100%' }} onClick={handleClearButton}>
            Clear
          </Button>
        </div>
      </div>
    </form>
  );
};

export default NumberMaskForm;
